var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7083 166.667C30.3125 166.667 20.8333 145.833 20.8333 125C20.8333 104.167 30.3125 83.3333 58.7083 83.3333C96.5937 83.3333 153.406 166.667 191.292 166.667C219.687 166.667 229.167 145.833 229.167 125C229.167 104.167 219.687 83.3333 191.292 83.3333C153.406 83.3333 96.5937 166.667 58.7083 166.667V166.667Z",
    stroke: "#6A9BF4",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.8e3588489123e14947e7c1e47c07eb06.svg";
export { ForwardRef as ReactComponent };